import {React,useState} from 'react'
import { Container,Row,Col,Form,FormGroup } from 'react-bootstrap'
import Helmet from '../components/Helmet/Helmet'
import { Link , useNavigate } from 'react-router-dom'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { auth } from '../firebase.config'
import { toast } from 'react-toastify'
import '../assets/style/login.css'


const Login = () => {

    const [email,setEmail] = useState('')
    const [password,setPassword] = useState('')
    const [loading,setLoading] = useState(false)

    const navigate = useNavigate()

    const Login = async(e)=>{
        e.preventDefault()
        setLoading(true)

        try{

            const userCredential = await signInWithEmailAndPassword(auth,email,password)
            const user = userCredential.user
            console.log(user)
            setLoading(false)
            toast.success('Successfully logged in')
            navigate('/checkout')

        }catch (error){
            setLoading(false)
            toast.error('Email or Password Wrong')
        }

    }


    return (
        <>
            <Helmet title='Login'/>
            <section>
                <Container>
                    <Row>
                        {
                            loading ? <Col className='text-center' lg='12'> <h4 className='fw-bold'>Loading...</h4> </Col>:
                            <Col lg='6' className='m-auto text-center'>
                                <h3 className='fw-bold mb-4'>Login</h3>

                                <Form className='auth__form' onSubmit={Login}>
                                    <FormGroup className='form__group'>
                                        <input value={email} onChange={(e)=>setEmail(e.target.value)} type="email" placeholder='Email' />
                                    </FormGroup>
                                    <FormGroup className='form__group'>
                                        <input value={password} onChange={(e)=>setPassword(e.target.value)} type="password" placeholder='Password' />
                                    </FormGroup>
                                    <button type='submit' className='buy__btn auth__btn'>Login</button>
                                    <p>Don't have an account? <Link to='/signup'> Create an account</Link></p>
                                </Form>

                            </Col>
                        }
                        <Col lg='6'>

                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default Login